import {Card} from "@/components/card/Card.tsx";
import {PerformanceDataType, PerformanceDataTypeLabel} from "@/lib/types/checks.ts";

export interface DaysToExpireOverviewProps {
  dataType: PerformanceDataType;
  days: number;
}

export const DaysToExpireOverview = ({dataType, days}: DaysToExpireOverviewProps) => (
  <Card variant="white">
    <p className="pulseTextH2Bold">{PerformanceDataTypeLabel[dataType]}</p>
    {days >= 1 && (
      <p className="mb-0">
        <strong>{Math.floor(days)} days</strong> remaining before expiry.
      </p>
    )}
    {days < 1 && (
      <>
        <p className="mb-2">
          <strong className="text-warning">Unable to determine expiry date.</strong>
        </p>
        <p className="mb-0 fs-7 text-muted">
          If this is a new Check, it may take several hours for the expiry date to be verified. Otherwise, please check
          that your certificate/domain is valid as soon as possible.
        </p>
      </>
    )}
  </Card>
);
